import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import Grid from '@mui/material/Grid';
import useTheme from '@mui/material/styles/useTheme';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FingoDateRangePicker } from '../datePickers';
import { getFilterByNameFromHistory } from '../../helpers';
import dayjs from '../../config/dayjs';

const DatesFilter = ({
  anchorEl,
  close,
  dates,
  setDates,
  states,
  setStates,
}) => {
  const theme = useTheme();
  const history = useHistory();
  /* We can get the default values from URL search or filters */
  const getDefaultDate = (name) => {
    const urlSearch = dayjs(
      getFilterByNameFromHistory(history, name),
      'YYYY-MM-DD',
    ).toDate();
    const filter = dates[name].toDate();
    // eslint-disable-next-line no-restricted-globals
    return isNaN(urlSearch) ? filter : urlSearch;
  };
  const [datesState, setDatesState] = useState([
    {
      startDate: getDefaultDate('dateIssued_Gte'),
      endDate: getDefaultDate('dateIssued_Lte'),
      key: 'range',
      color: theme.palette.primary.main,
    },
  ]);
  const eraser = { ...states };
  const save = () => {
    setDates({
      dateIssued_Gte: dayjs(datesState[0].startDate),
      dateIssued_Lte: dayjs(datesState[0].endDate),
    });
    setStates({
      ...eraser,
      dateIssued_Gte: dayjs(datesState[0].startDate).format('YYYY-MM-DD'),
      dateIssued_Lte: dayjs(datesState[0].endDate).format('YYYY-MM-DD'),
    });
    close();
  };
  const dateChange = ({ range }) => {
    setDatesState([{ ...range }]);
  };
  return (
    <Menu
      id="date-filter"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={close}
      keepMounted
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Grid container spacing={2}>
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          justifyContent="center"
        >
          <FingoDateRangePicker
            onChange={dateChange}
            ranges={datesState}
            direction="horizontal"
            color={theme.palette.primary.main}
          />
        </Grid>
        <Grid container item xs={12} justifyContent="flex-end" margin="4px">
          <Button
            id="save-date-filter"
            variant="contained"
            color="primary"
            onClick={save}
            size="small"
          >
            Buscar
          </Button>
        </Grid>
      </Grid>
    </Menu>
  );
};

DatesFilter.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  anchorEl: PropTypes.object,
  close: PropTypes.func.isRequired,
  dates: PropTypes.shape({
    dateIssued_Gte: PropTypes.instanceOf(dayjs),
    dateIssued_Lte: PropTypes.instanceOf(dayjs),
  }).isRequired,
  setDates: PropTypes.func.isRequired,
  setStates: PropTypes.func,
  states: PropTypes.shape({}),
};
DatesFilter.defaultProps = {
  anchorEl: null,
  setStates: () => {},
  states: {},
};

export default DatesFilter;
